import type { TMessages } from '@/types/TMessages'

export const messages = {
  becomePartnersHeader: 'Стать партнёром',
  ourParntersHeader: 'Наши партнеры',
  manufacturersHeader: 'Производители',
} satisfies TMessages
